<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="x-SECTION-BREAK"> </p>
<p class="x1PART-NUM" id="toc_marker-4"><a href="#/Contents#toc_marker-4">Part 1</a></p>
<p class="x1PART-TTL">AUTUMN<br/>YEAR 3988 IN THE AGE OF THE REALMS </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part-1.vue?8c1c62ea